import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';
import { useDispatch, useSelector } from 'react-redux';

import { updateChecklistItem } from 'actions/checklist';

const completeChecklistItemMutation = gql`
  mutation completeChecklistItem($checklistItem: ChecklistItem!) {
    result: completeChecklistItem(checklistItem: $checklistItem) {
      ... on UpdateChecklistItemPayload {
        success
      }
      ... on Error {
        message
      }
    }
  }
`;

export const useCompleteChecklistItem = item => {
  const dispatch = useDispatch();
  const checklist = useSelector(state => state.checklist);
  const [completeChecklistItem, { loading, error }] = useMutation(
    completeChecklistItemMutation,
    {
      onCompleted: ({ result }) => {
        if (result?.success) {
          dispatch(updateChecklistItem(item, true));
        }
      },
    }
  );

  const completeItem = () => {
    if (checklist[item]) {
      return;
    }

    completeChecklistItem({
      variables: {
        checklistItem: item,
      },
    });
  };

  return {
    completeChecklistItem: completeItem,
    loading,
    error,
  };
};
